/**
 * In standalone vite dev (port 5173) the API runs on localhost:4000. When the rider
 * build is served by the API itself (same origin), use that origin instead.
 */
function detectApiBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_API_URL as string | undefined;
  if (fromEnv) return fromEnv;
  if (typeof window === 'undefined') return 'http://localhost:4000';
  const { pathname, origin } = window.location;
  if (pathname === '/rider' || pathname.startsWith('/rider/')) return origin;
  return 'http://localhost:4000';
}

export const apiBaseUrl = detectApiBaseUrl();
